import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import classNames from 'classnames';
import GlobalSearchContent from './content';

const TIMEOUT_DELAY = 700;

class GlobalSearch extends React.Component {
  constructor(props) {
    super(props);
    this.timer = 0;
    this.state = {
      showContent: false,
      keyword: null,
    };
  }

  componentDidMount() {
    Utils.OutsideClickHandler.registerNode(this.root,
      this._toggleSearch.bind(this, false));
  }

  componentWillUnmount() {
    Utils.OutsideClickHandler.removeNode(this.root);
  }

  _onFilterChange(keyword) {
    this.setState({ keyword });
    if (this.timer) {
      clearTimeout(this.timer);
    }

    // Manually toggle isLoading to true when keyword changes and isloading is false.
    if (Utils.Helper.isNonEmptyString(keyword)) {
      if (!this.props.globalSearch.isLoading) {
        this.props.dispatch(ReduxActions.globalSearch.requestSearch());
      }

      this.timer = setTimeout(() => {
        this.props.dispatch(ReduxActions.globalSearch.search(keyword.trim()));
      }, TIMEOUT_DELAY);
    }
  }

  _toggleSearch = (val) => {
    if (Utils.Helper.isNullOrUndefined(val)) {
      this.setState(prevState => ({
        showContent: !prevState.showContent,
      }));
    } else {
      this.setState({ showContent: val });
    }

    if (!this.state.showContent) {
      this.setState({ keyword: null });
      if (this.props.globalSearch.tasks.length !== 0
        || this.props.globalSearch.jobs.length !== 0) {
        this.props.dispatch(ReduxActions.globalSearch.resetSearchResults());
      }
    }
  }

  _onClickItem(data) {
    this._toggleSearch(false);
    this.props.onClickItem(data);
  }

  render() {
    const className = classNames('vf-global-search', this.props.className);

    return (
      <div className={className} ref={(c) => { this.root = c; }}>
        <Components.Button
          className="vf-global-search__button"
          iconClassName="versa-search"
          isOverflowVisible={false}
          onClick={() => this._toggleSearch()}
          showShadow={false}
        />

        <GlobalSearchContent
          isLoading={this.props.globalSearch.isLoading}
          isOpened={this.state.showContent}
          jobs={this.props.globalSearch.jobs || []}
          onChange={val => this._onFilterChange(val)}
          onClickItem={item => this._onClickItem(item)}
          tasks={this.props.globalSearch.tasks || []}
          value={this.state.keyword}
        />
      </div>
    );
  }
}

GlobalSearch.displayName = 'Global Search';

GlobalSearch.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  globalSearch: PropTypes.shape(),
  onClickItem: PropTypes.func.isRequired,
};

GlobalSearch.defaultProps = {
  className: null,
  globalSearch: {},
};

function mapStateToProps(state) {
  const { globalSearch } = state;
  return { globalSearch };
}

export default connect(mapStateToProps)(GlobalSearch);
